/**
 * A station scan of an item that was pulled from production (store
 * cancellation or order edit) gets 409 with meta.code ITEM_CANCELLED.
 * ajax() reports every such error here; CancelledItemDialog listens and shows
 * the blocking popup, whatever page made the request.
 */
export const ITEM_CANCELLED_CODE = "ITEM_CANCELLED";
export const ITEM_CANCELLED_EVENT = "riverr:item-cancelled";

/** The cancelled item from an axios error, or null. */
export function cancelledItemFromError(error) {
  const meta = error?.response?.data?.meta;
  if (!meta || meta.code !== ITEM_CANCELLED_CODE) return null;
  const item = meta.cancelledItem;
  if (!item || !item.unitId) return null;
  return {
    ...item,
    message: error?.response?.data?.message || "",
  };
}

// The same scan can fire several requests (page load + action). One popup.
let lastShown = { unitId: "", at: 0 };
const REPEAT_WINDOW_MS = 1500;

export function reportCancelledItem(error) {
  const item = cancelledItemFromError(error);
  if (!item || typeof window === "undefined") return false;
  const now = Date.now();
  if (lastShown.unitId === item.unitId && now - lastShown.at < REPEAT_WINDOW_MS) {
    return true;
  }
  lastShown = { unitId: item.unitId, at: now };
  window.dispatchEvent(new CustomEvent(ITEM_CANCELLED_EVENT, { detail: item }));
  return true;
}

/** Test hook. */
export function resetCancelledItemAlert() {
  lastShown = { unitId: "", at: 0 };
}

/** Label for the popup's item line, e.g. "Muted Hoodie — XS / Black". */
export function cancelledItemTitle(item = {}) {
  const product = String(item.product || "").trim();
  const variant = String(item.variant || "").trim();
  if (product && variant && !product.includes(variant)) return `${product} — ${variant}`;
  return product || variant || "This item";
}

/** Where the piece is in production, for the popup. */
export function cancelledItemStage(item = {}) {
  if (item.qcPassed) return "Already passed QC";
  if (item.printed) return "Already printed";
  return "Not printed yet";
}
